"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GridModule = _interopRequireDefault(require("./Grid.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function GutterField(_ref) {
  var children = _ref.children,
      gutterBottom = _ref.gutterBottom;
  var inlineStyle = (0, _react.useMemo)(function () {
    return {
      marginBottom: gutterBottom
    };
  }, []);
  return _react.default.createElement("div", {
    className: _GridModule.default.gutterField,
    style: inlineStyle
  }, children);
}

var _default = _react.default.memo(GutterField);

exports.default = _default;
GutterField.propTypes = {
  children: _propTypes.default.node.isRequired,
  gutterBottom: _propTypes.default.number
};